import { Popover } from "antd";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Icon } from "@components/Icon";
import {
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE,
} from "@static/PERMISSION_KEY";

const SectionTableAction = styled.div`
  display: flex;
  gap: 8px;
`;

export const getCustomerTableColumns = ({
  permission,
  onHandleEdit,
  onHandleDelete,
  showConfirmation,
}) => {
  return [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      fixed: "left",
      width: 80,
      sorter: (a, b) => a.index - b.index,
    },
    {
      title: "Name",
      dataIndex: "customer_name",
      key: "customer_name",
      fixed: "left",
    },
    {
      title: "email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (text, item, index) => {
        return (
          <SectionTableAction key={index}>
            {_.includes(permission, KEY_DEVICE_MANAGEMENT_CUSTOMERS_UPDATE) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Edit</div>}
              >
                <ICON_TABLE_EDIT
                  width={24}
                  height={24}
                  onClick={() => onHandleEdit({ item })}
                />
              </Popover>
            )}
            {_.includes(permission, KEY_DEVICE_MANAGEMENT_CUSTOMERS_DELETE) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Delete</div>}
              >
                <ICON_TABLE_DELETE
                  width={24}
                  height={24}
                  onClick={() =>
                    showConfirmation({
                      title: "Delete",
                      onConfirm: () => onHandleDelete({ item }),
                    })
                  }
                />
              </Popover>
            )}
          </SectionTableAction>
        );
      },
    },
  ];
};
